import Commons from "../../../Services/Common/Common";

export const M_RNM_BASIC_02_Schema = {
  fields: {
    gongjongCd: { initial: '', label: '공정', required: 'Y' },
    location: { initial: '', label: '장소', required: 'Y' },
    content: { initial: '', label: '내용', required: 'Y' },
  },

  mapper: {
    search1: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd ?? ''),
    },
    search2: {
      DepCd: (context) =>
        Commons.EncryptAES(context.depCd ?? context.userInfo?.depCd ?? ''),
      UserId: (context) => context.userInfo?.userid,
    },
    save1: {
      NearMissSeq: (row) => row.nearMissSeq || null,
      CustCd: (_, context) => Commons.EncryptAES(context.userInfo?.custCd ?? ''),
      Gubun: (row) => Commons.EncryptAES(row.gubun || ''),
      GongjongCd: (row) => Commons.EncryptAES(row.gongjongCd || ''),
      OccurDate: (row) => Commons.EncryptAES(row.occurDate || ''),
      Location: (row) => Commons.EncryptAES(row.location || ''),
      Content: (row) => Commons.EncryptAES(row.content || ''),
      TodaySafety: (row) => Commons.EncryptAES(row.todaySafety || ''),
      ReductionMeasures: (row) => Commons.EncryptAES(row.reductionMeasures || ''),
      IsRisk: (row) => Commons.EncryptAES('Y'),
      ResultContent: (row) => Commons.EncryptAES('' || ''),
      DiscovererId: (_, context) => context.userInfo?.userid ?? '',
      ManagerId: (row) => Commons.EncryptAES('' || ''),
      Status: (row) => Commons.EncryptAES('0' || ''),
      Remark: (row) => Commons.EncryptAES('' || ''),
      UserId: (_, context) => context.userInfo?.userid ?? '',
      Images: (row) => row.images || [],
    },
    save2: {
      WorkCd: (row) => Commons.EncryptAES(row.workCd),
      DepCd: (_, context) => Commons.EncryptAES(context.userInfo?.depCd),
      BeforeComment: (row) => Commons.EncryptAES(row.beforeComment),
      BeforeImage: (row) => Commons.EncryptAES(row.beforeImage),
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};